import { createContext, useContext } from 'react';

import AppStore from './AppStore';

const storeContext = createContext({ AppStore });

export function useStores(): { AppStore: typeof AppStore } {
  return useContext(storeContext);
}
